import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class RequestParserInterceptor implements HttpInterceptor {
  constructor(
    private notification: NzNotificationService,
    private readonly injector: Injector
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          throw error;
        }

        const errorObj = error.error.errors;

        if (errorObj) {
          this.createNotifications(errorObj);
        }

        throw errorObj;
      })
    );
  }

  private createNotifications(errors: NotificationResponseModel[]): void {
    const translateService = this.injector.get(TranslateService, null);
    if (!translateService) {
      throw new Error('TranslateService is not available');
    }

    for (const error of errors) {
      const textToTranslate: string[] = [
        error.key ?? '',
        ...(error.messages ?? []),
      ];

      translateService.get(textToTranslate).subscribe(result => {
        this.notification.create(
          'error',
          result[error.key ?? ''] || 'Error',
          error.messages?.reduce((str, err) => {
            if (!err) return '';
            return str + (result[err] ?? err);
          }, '') ?? ''
        );
      });
    }
  }
}

interface NotificationResponseModel {
  key?: string;
  messages?: string[];
}
